import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, MdArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { DialogTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function ResearcherSettings() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();

    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [personDetails, setPersonDetails] = useState({
        userName: "",
        mobile: "",
        email: "",
    }
    )

    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };
    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.removeItem('logDetails');
        sessionStorage.removeItem('logDetails');
        setOpenError(false);
        navigate('/loginas')
    };

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true)

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/researchers/${logDetails.email}`
            axios.get(apiUrl, configToken)
                .then((response) => {
                    // console.log(response.data);
                    // const [grade, section] = (response.data.assignedClass).split("-");
                    setPersonDetails({
                        userName: response.data.userFullName,
                        mobile: response.data.contactNumber,
                        email: response.data.userEmail,
                    })
                    localStorage.setItem('name', response.data.userFullName);
                    localStorage.setItem('mobile', response.data.contactNumber)
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    handleClickOpenError("error occured")
                });
        }
    }, [])

    const handleDeleteAccount = () => {
        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`
            },
        };

        const filterDetails = {
            receiverEmail: personDetails.email,
            userRole: "RESEARCHER"
        }


        axios.post(`${web_url}/api/invitations/admin/filter`, filterDetails, config).then((resInv) => {
            console.log('res inv: ', resInv);

            if (resInv.data.length === 0) {
                axios.delete(`${web_url}/api/auth/researchers/${personDetails.email}`, configToken)
                    .then((response) => {
                        console.log('res inv: ', "done");
                        localStorage.clear();
                        sessionStorage.clear();
                        setIsLoading(false);
                        navigate('/loginas')
                    })
                    .catch((err1) => {
                        console.log(err1.response)
                        if (err1.response) {

                            if (err1.response.data.error) {
                                handleClickOpenError(err1.response.data.error);
                            } else if (err1.response.data.message) {
                                handleClickOpenError(err1.response.data.message);
                            } if (err1.response.data.token) {
                                handleClickOpenError(err1.response.data.token);
                            } else {
                                handleClickOpenError("An unknown error occured");
                            }

                        }
                        setIsLoading(false);
                    })
            } else {
                console.log('res inv: 2 ');
                axios.delete(`${web_url}/api/invitations/admin/${resInv.data[0].id}`, configToken).then((resDelInv) => {
                    axios.delete(`${web_url}/api/auth/researchers/${personDetails.email}`, configToken)
                        .then((response) => {
                            localStorage.clear();
                            sessionStorage.clear();
                            setIsLoading(false);
                            navigate('/loginas')
                        })
                        .catch((err) => {
                            if (err.response) {
                                // console.log(err.response)
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } if (err.response.data.token) {
                                    handleClickOpenError(err.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            }
                            setIsLoading(false);
                        })
                }).catch((resDelErr) => {
                    setIsLoading(false);
                    if (resDelErr.response) {
                        // console.log(err.response)
                        if (resDelErr.response.data.error) {
                            handleClickOpenError(resDelErr.response.data.error);
                        } else if (resDelErr.response.data.message) {
                            handleClickOpenError(resDelErr.response.data.message);
                        } if (resDelErr.response.data.token) {
                            handleClickOpenError(resDelErr.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                })
            }

        }).catch((errInv) => {
            setIsLoading(false);
            if (errInv.response) {
                // console.log(err.response)
                if (errInv.response.data.error) {
                    handleClickOpenError(errInv.response.data.error);
                } else if (errInv.response.data.message) {
                    handleClickOpenError(errInv.response.data.message);
                } if (errInv.response.data.token) {
                    handleClickOpenError(errInv.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
        })
    }

    return (
        <div>
            <div className="">
                <div className="xl:hidden pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
                    <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            if (!isLoading) {
                                navigate('/mobile/researcher/dashboard')
                            }
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            if (!isLoading) {
                                navigate('/mobile/researcher/dashboard')
                            }
                        }} />
                        <p className="font-bold text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t153')}</p>
                    </div>
                </div>

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="flex flex-col items-center pt-[20px] xl:pt-[40px] 2xl:pt-[60px]">
                                {/* <img className="xl:hidden h-[100px] rounded-full" src="/images/img.jpg" alt="profile" /> */}
                                <div className="flex flex-col pt-[20px] justify-center items-center pt-[5px]">
                                    <p className="xl:hidden font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">{personDetails.userName}</p>
                                    <p className="hidden xl:block font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">{t('t153')}</p>
                                    <p className="xl:hidden font-normal text-[19px] md:text-[27px] md:text-[35px] xl:text-[20px] text-black">{personDetails.mobile}</p>
                                </div>
                            </div>
                            <hr className=" border-gray-400 flex items-center mx-[30px] mt-[20px] xl:ml-[90px]" />
                            <div className="pt-[30px] xl:pl-[40px]">
                                <div className="flex w-full items-center justify-between mt-[10px]">
                                    <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                        {t('t154')}
                                    </p>
                                    <MdArrowRight size={30} className="xl:hidden mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" onClick={() => navigate('/mobile/researcher/editprofile')} />
                                    <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" />
                                </div>
                                <div className="flex w-full items-center justify-between mt-[10px]">
                                    <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                        {t('t155')}
                                    </p>
                                    <MdArrowRight size={30} className="mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" onClick={() => navigate('/mobile/researcher/changepassword')} />
                                </div>
                                <div className="flex w-full items-center justify-between mt-[10px]">
                                    <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                        {t('t156')}
                                    </p>
                                    <MdArrowRight size={30} className="mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" onClick={() => navigate('/mobile/researcher/help')} />
                                </div>
                                <div className="flex w-full items-center justify-between mt-[10px]">
                                    <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                        {t('t157')}
                                    </p>
                                    <MdArrowRight size={30} className="mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" onClick={() => navigate('/mobile/researcher/termsandconditions')} />
                                </div>

                                <div onClick={() => handleClickOpen()} className="flex w-full items-center justify-between mt-[10px]">
                                    <p className=" text-[#ff2d00] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                        {t('t158')}
                                    </p>
                                </div>

                                <div onClick={() => handleClickOpen2()} className="flex w-full items-center justify-between mt-[20px] pb-[150px]">
                                    <p className="text-[#ff2d00] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                        {t('t159')}
                                    </p>
                                </div>
                            </div>
                        </>
                }
            </div>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t160')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => { handleDeleteAccount() }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t161')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        localStorage.clear();
                                        sessionStorage.clear();
                                        navigate('/loginas')
                                    }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

        </div>
    )
}

export default ResearcherSettings;